import { SWReactIcons } from "@similarweb/icons";
import { PlainTooltip } from "@similarweb/ui-components";

import { StyledInfoIcon, StyledRadioButton, StyledRadioContainer } from "./styles";

export interface IRadioSelectItem {
    id: string;
    text: string;
    disabled?: boolean;
    tooltip?: string;
}

type CommonRadioSelectProps = {
    items: readonly IRadioSelectItem[];
    selected: string;
    size?: "sm" | "lg";
    className?: string;
    onSelect(id: string): void;
};

export const RadioSelect = (props: CommonRadioSelectProps) => {
    const { items, selected, size = "lg", className, onSelect } = props;

    return (
        <div
            className={className}
            data-automation="radio-options-container"
        >
            {items.map((item) => (
                <StyledRadioContainer
                    key={item.id}
                    data-automation="radio-option"
                    data-automation-id={item.id}
                >
                    <StyledRadioButton
                        itemLabel={item.text}
                        onClick={() => onSelect(item.id)}
                        itemSelected={item.id === selected}
                        buttonSize={size}
                    />
                    {item.disabled ? (
                        <StyledInfoIcon>
                            <SWReactIcons
                                iconName="locked"
                                size="xs"
                            />
                        </StyledInfoIcon>
                    ) : null}
                    {item.tooltip ? (
                        <PlainTooltip tooltipContent={item.tooltip}>
                            <StyledInfoIcon>
                                <SWReactIcons
                                    iconName="info"
                                    size="xs"
                                />
                            </StyledInfoIcon>
                        </PlainTooltip>
                    ) : null}
                </StyledRadioContainer>
            ))}
        </div>
    );
};
